export default __webpack_public_path__ + "static/media/museum-thumbnail.c76ca2c4.jpg";